import { render } from "./pricedetails.vue?vue&type=template&id=646c55d9"
import script from "./pricedetails.vue?vue&type=script&lang=js"
export * from "./pricedetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__